module.exports = __webpack_public_path__ + "assets/img/12.996a12a8.jpg";